import { Component, Injectable, OnInit } from '@angular/core';
import { FenceService } from '../../../../services/configurators-2d/applications/fence.service';
import { TranslateService } from '@ngx-translate/core';
import { FenceLocation } from 'src/app/models/configurators-2d/applications/fence/fence-location';
import { FenceConfiguratorItem } from '../../configurator/applications/fence-configurator-item';
import { IBaseComponent } from '../../configurator/i-base-component';
import { FenceConstants } from 'src/app/models/configurators-2d/applications/fence/fence-constants';

@Component({
  selector: 'ng-fence-environment',
  templateUrl: './environment.component.html',
})
@Injectable({ providedIn: 'root' })
export class FenceEnvironmentComponent extends FenceConfiguratorItem implements OnInit, IBaseComponent {
  locations: FenceLocation[];

  //URL de base des images
  baseImgURL = undefined;

  currentLang: string;

  maxWallHeight = FenceConstants.MAX_WALL_HEIGHT;

  constructor(
    fenceService: FenceService,
    private translate: TranslateService
  ) {
    super(fenceService);
    this.baseImgURL = this.service.apiUrl;
    this.currentLang = this.translate.getBrowserLang();
  }

  ngOnInit(): void {
    this.service.getLocations<FenceLocation>().then(locations => {
      this.locations = [...locations].sort((a, b) => a.displayOrder - b.displayOrder);
      if (!this.configuration.location && this.locations) {
        this.selectLocation(this.locations.find(_ => _));
      }
    });
  }

  /**
   * Fonction de sélection de l'emplacement
   * @param location emplacement à sélectionner
   */
  selectLocation(location: FenceLocation) {
    this.configuration.location = location;

    if (!location.isOnWall) {
      this.configuration.wallHeight = null;
    } else {
      // si on choisi un muret, alors on ne peut pas avoir de plaque de soubassement
      this.configuration.sides?.forEach(s => s.sections.forEach(se => (se.hasBasePlates = false)));
    }
  }

  /**
   * Fonction de toggle du champs Hauteur du muret
   * @returns boolean
   */
  hasWall(): boolean {
    if (
      this.locations &&
      this.configuration.location &&
      this.locations.filter(e => e.id === this.configuration.location.id).length > 0
    ) {
      return this.locations.filter(e => e.id === this.configuration.location.id)[0].isOnWall;
    } else {
      return false;
    }
  }

  /**
   * Fonction de sélection de la hauteur des murets
   */
  selectWallHeight(event: any) {
    this.configuration.wallHeight = event.target.value;
  }

  /**
   * Fonction de détermination si l'emplacement est sélectionné ou non
   * @param id id de l'emplacement
   * @returns boolean
   */
  isLocationSelected(id: number) {
    if (this.configuration.location != null) {
      return this.configuration.location.id === id;
    }
  }

  isNextButtonActive(): boolean {
    return this.configuration.location &&
    (
      !this.configuration.location.isOnWall ||
      (this.configuration.wallHeight > 0 && this.configuration.wallHeight <= this.maxWallHeight)
    );
  }

  checkPageChangeCapability(): boolean {
    return this.isNextButtonActive();
  }
}
